import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Spinner } from '../../../../../components/Spinner';
import { useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../hooks/useAuth';
import { useEnv } from '../../../../../context/env-context';
import { makeRequest } from '../../../../../utils/makeRequest';

function ConsumerPopoverJobsForm({
  target,
  popoverJobsForm,
  closePopoverJobsForm,
  getJobs,
  consumerId,
}) {
  const { apiOriginMonitor } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [spinner, setSpinner] = useState(false);
  const [fields, setFields] = useState({ last: 'NO', num: null });

  const close = () => {
    setFields({ last: 'NO', num: null });
    closePopoverJobsForm();
  };

  const launchJob = async () => {
    setSpinner(true);

    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginMonitor}/${popoverJobsForm}`,
      method: 'POST',
      data: JSON.stringify({
        consumerId,
        last: fields.last !== 'NO',
        num: Number(fields.num) || null,
      }),
    };

    try {
      await makeRequest(config);
      await getJobs();

      close();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <Overlay
      show={!!popoverJobsForm}
      target={target.current}
      placement="right"
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [30, 10] } }] }}
    >
      {props => (
        <Popover {...props} className="custom-popover">
          <Popover.Body className="bo-common-popover-form-menu bo-w-200">
            <Spinner visible={spinner} size={36}>
              <p className="bo-common-text-bold">TYPE: {popoverJobsForm.toUpperCase()}</p>
              <Form.Label className="bo-common-popover-form-menu-label">Last:</Form.Label>
              <Form.Select
                className="bo-common-popover-form-menu-input"
                value={fields.last}
                onChange={e => setFields({ ...fields, last: e.target.value })}
              >
                <option value="NO">No</option>
                <option value="YES">Yes</option>
              </Form.Select>
              <Form.Label className="bo-common-popover-form-menu-label">Num:</Form.Label>
              <NumericFormat
                type="text"
                className="bo-common-popover-form-menu-input"
                value={fields.num}
                onChange={e => setFields({ ...fields, num: e.target.value })}
                customInput={Form.Control}
                decimalScale={0}
              />
              <div className="mt-3 d-flex justify-content-between">
                <Button className="bo-common-button" onClick={launchJob}>
                  Launch
                </Button>
                <Button className="bo-common-button" onClick={close}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      )}
    </Overlay>
  );
}

export default ConsumerPopoverJobsForm;
